// extracted by mini-css-extract-plugin
export var Base = "Header-module--Base--86e0a";
export var BurgerMenu = "Header-module--BurgerMenu--6ccd3";
export var CountyIdentifier = "Header-module--CountyIdentifier--48d4f";
export var CountyLinks = "Header-module--CountyLinks--fdacb";
export var InnerWrapper = "Header-module--InnerWrapper--03ff9";
export var IsActive = "Header-module--IsActive--7dbbe";
export var Logo = "Header-module--Logo--cc66c";
export var PrimaryLinks = "Header-module--PrimaryLinks--50c86";
export var Selector = "Header-module--Selector--eeaf1";
export var SocialLinks = "Header-module--SocialLinks--74bb5";
export var Wrapper = "Header-module--Wrapper--85f7d";
export var isFloating = "Header-module--isFloating--bdf8d";
export var slidein = "Header-module--slidein--091b0";